<template>
    <Layout header-class="header-left-align" nav-alignment="left">
			<div class="top-page"
					 :style="{'background-image': `url(${require(`@/assets/images/index-banner.png`)})`}">
				<h2 class="banner-title">产品价格</h2>
				<p class="banner-note">分级透明 · 明码标价</p>
				<p class="banner-info">对标 2026 年 Web3 安全行业通用收费标准，覆盖四大核心业务，满足 KYB 合规核验要求。</p>
			</div>

			<!-- 定价原则 -->
			<section class="module principle">
				<div class="center70">
					<div class="principle-grid">
						<div class="p-item">
							<div class="p-label">适用主体</div>
							<div class="p-value">Isafeclub LIMITED</div>
						</div>
						<div class="p-item">
							<div class="p-label">结算币种</div>
							<div class="p-value">美元（对公转账）、合规数字资产，可开具商业服务发票</div>
						</div>
						<div class="p-item">
							<div class="p-label">优惠规则</div>
							<div class="p-value">年度订阅统一享 15% 年费折扣，长期合作客户享批量议价</div>
						</div>
						<div class="p-item">
							<div class="p-label">合规匹配</div>
							<div class="p-value">与开户申请材料 100% 匹配，满足 KYB 合规核验</div>
						</div>
					</div>
				</div>
			</section>

			<!-- （一）定制化项目服务费 -->
			<section class="module block-gray">
				<div class="center70">
					<div class="section-head">
						<span class="sec-index">一</span>
						<h2 class="title">定制化 Web3 安全项目服务费</h2>
					</div>
					<p class="sec-lead">依据代码复杂度、审计周期、服务场景分级定价，包含智能合约审计、漏洞整改、攻防演练、盗案应急溯源、跨链安全整改等全场景服务。</p>

					<h3 class="sub-title">1.1 智能合约常规审计服务</h3>
					<div class="price-cards">
						<div class="price-card">
							<div class="pc-head">基础标准版</div>
							<div class="pc-scene">简单合约 / ERC20 / 单链 DApp</div>
							<div class="pc-price">$5,000 <span>- $15,000</span></div>
							<ul class="pc-list">
								<li>适配 600 行以内常规代码</li>
								<li>自动化扫描 + 人工复核</li>
								<li>基础漏洞修复指导</li>
								<li>标准审计报告</li>
								<li>周期 7-10 个工作日</li>
							</ul>
						</div>
						<div class="price-card featured">
							<div class="pc-tag">进阶</div>
							<div class="pc-head">进阶专业版</div>
							<div class="pc-scene">常规 DeFi / 质押挖矿 / NFT 协议</div>
							<div class="pc-price">$15,000 <span>- $40,000</span></div>
							<ul class="pc-list">
								<li>多合约联动逻辑适配</li>
								<li>深度人工代码审计</li>
								<li>动态漏洞检测、合规性校验</li>
								<li>完整整改方案</li>
								<li>周期 10-20 个工作日</li>
							</ul>
						</div>
						<div class="price-card">
							<div class="pc-head">旗舰定制版</div>
							<div class="pc-scene">复杂 DeFi / 借贷 / 永续 / 跨链协议</div>
							<div class="pc-price">$40,000 <span>- $100,000+</span></div>
							<ul class="pc-list">
								<li>跨链同步、ZK 验证、自定义算法</li>
								<li>形式化验证</li>
								<li>经济攻击模型推演</li>
								<li>全维度风险排查</li>
								<li>周期 20-40 个工作日</li>
							</ul>
						</div>
					</div>

					<h3 class="sub-title">1.2 专项应急安全项目服务</h3>
					<table class="price-table">
						<thead>
							<tr>
								<th>服务项目</th>
								<th>收费标准</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>黑客攻击应急溯源修复</td>
								<td>基础溯源固定服务费 <b>$20,000</b> 起，资产追回落地部分收取 <b>5%-10%</b> 项目服务费</td>
							</tr>
							<tr>
								<td>交易所 / 公链年度安全顾问</td>
								<td>年度打包服务费 <b>$50,000 - $120,000/年</b>，含季度巡检、攻防模拟、应急处置、专属咨询</td>
							</tr>
							<tr>
								<td>加急审计服务</td>
								<td>基础价格上浮 <b>100%</b>，优先排期、缩短 50% 服务周期</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>

			<!-- （二）SaaS 订阅定价 -->
			<section class="module">
				<div class="center70">
					<div class="section-head">
						<span class="sec-index">二</span>
						<h2 class="title">Web3 安全 SaaS 软件订阅定价</h2>
					</div>
					<p class="sec-lead">面向个人开发者、项目团队、企业机构提供云端自动化安全工具，分月付 / 年付模式，年付享 15% 专属优惠。</p>

					<div class="price-cards">
						<div class="price-card">
							<div class="pc-head">个人开发者版</div>
							<div class="pc-scene">基础权限</div>
							<div class="pc-price">$499<span>/月</span></div>
							<div class="pc-year">年订阅 $5,090/年（立省 15%）</div>
							<ul class="pc-list">
								<li>基础合约漏洞扫描</li>
								<li>公共链上数据查询</li>
								<li>每日安全风险简报</li>
								<li>工具基础试用权限</li>
							</ul>
						</div>
						<div class="price-card featured">
							<div class="pc-tag">热门</div>
							<div class="pc-head">中小企业版</div>
							<div class="pc-scene">主流项目适配</div>
							<div class="pc-price">$1,299<span>/月</span></div>
							<div class="pc-year">年订阅 $13,250/年（立省 15%）</div>
							<ul class="pc-list">
								<li>全品类漏洞扫描</li>
								<li>7×24 链上异常监控</li>
								<li>大额转账预警、月度报告</li>
								<li>5 人团队账号权限</li>
								<li>基础技术运维支持</li>
							</ul>
						</div>
						<div class="price-card">
							<div class="pc-head">企业旗舰版</div>
							<div class="pc-scene">交易所 / 头部公链适配</div>
							<div class="pc-price">$3,999<span>/月</span></div>
							<div class="pc-year">年付 $40,790/年 · 私有部署 $80,000-$150,000/年</div>
							<ul class="pc-list">
								<li>全功能 SaaS 工具</li>
								<li>实时风控拦截</li>
								<li>专属技术运维、7×24 应急响应</li>
								<li>定制化监控脚本</li>
								<li>不限团队账号</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<!-- （三）软件硬件销售定价 -->
			<section class="module block-gray">
				<div class="center70">
					<div class="section-head">
						<span class="sec-index">三</span>
						<h2 class="title">安全软件及硬件销售定价</h2>
					</div>
					<p class="sec-lead">涵盖自研 Web3 安全商用软件、企业级安全硬件设备，支持一次性买断 + 年度维保双收费模式。</p>

					<h3 class="sub-title">3.1 安全软件销售定价</h3>
					<table class="price-table">
						<thead>
							<tr>
								<th>产品 / 服务</th>
								<th>价格</th>
								<th>说明</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>商用漏洞扫描工具（单机永久授权）</td>
								<td><b>$2,800/套</b></td>
								<td>终身使用，赠送 1 年免费版本更新</td>
							</tr>
							<tr>
								<td>链上监控客户端（企业授权）</td>
								<td><b>$6,800/套</b></td>
								<td>支持多节点绑定，适配团队常态化风控</td>
							</tr>
							<tr>
								<td>年度软件升级维保服务</td>
								<td><b>售价 20%/年</b></td>
								<td>更新漏洞库、优化检测引擎、技术适配升级</td>
							</tr>
						</tbody>
					</table>

					<h3 class="sub-title">3.2 安全硬件销售定价</h3>
					<table class="price-table">
						<thead>
							<tr>
								<th>产品 / 服务</th>
								<th>价格</th>
								<th>说明</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>节点安全加密硬件</td>
								<td><b>$1,999/台</b></td>
								<td>企业批量采购 10 台以上享 8 折优惠</td>
							</tr>
							<tr>
								<td>企业离线签名安全设备</td>
								<td><b>$4,599/台</b></td>
								<td>适配交易所、资管机构私钥安全防护</td>
							</tr>
							<tr>
								<td>硬件年度维保服务费</td>
								<td><b>售价 15%/年</b></td>
								<td>固件升级、故障检修、硬件安全检测</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>

			<!-- （四）会员订阅收费 -->
			<section class="module">
				<div class="center70">
					<div class="section-head">
						<span class="sec-index">四</span>
						<h2 class="title">年度会员订阅收费方案</h2>
					</div>
					<p class="sec-lead">三级会员体系，免费会员为基础体验，付费会员为核心收入，权益与定价一一对应，公开透明可核验。</p>

					<div class="price-cards">
						<div class="price-card">
							<div class="pc-head">普通免费会员</div>
							<div class="pc-price free">免费</div>
							<div class="pc-year">永久免费</div>
							<ul class="pc-list">
								<li>公开行业新闻</li>
								<li>通用安全报告阅览</li>
								<li>公开技术文档下载</li>
								<li>线上公开课旁观权限</li>
							</ul>
						</div>
						<div class="price-card">
							<div class="pc-head">个人专业会员</div>
							<div class="pc-price">$999<span>/年</span></div>
							<div class="pc-year">年度订阅</div>
							<ul class="pc-list">
								<li>解锁全部免费工具试用</li>
								<li>线上研讨会回放</li>
								<li>专属技术文档库</li>
								<li>基础漏洞模拟演练</li>
								<li>普通技术咨询权限</li>
							</ul>
						</div>
						<div class="price-card featured">
							<div class="pc-tag">核心</div>
							<div class="pc-head">企业精英会员</div>
							<div class="pc-price">$4,999<span>/年起</span></div>
							<div class="pc-year">基础版 $4,999/年（10 人）· 旗舰版 $9,999/年（30 人）</div>
							<ul class="pc-list">
								<li>会员专属 Telegram 技术社群</li>
								<li>一对一安全顾问服务</li>
								<li>白皮书 / 技术专利优先查阅</li>
								<li>免费攻防实战演练</li>
								<li>全球多区域办公室技术沙龙</li>
								<li>项目审计专属折扣、优先应急处置</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<!-- （五）通用结算与售后规则 -->
			<section class="module block-dark">
				<div class="center70">
					<div class="section-head light">
						<span class="sec-index">五</span>
						<h2 class="title">通用结算与售后规则</h2>
					</div>
					<div class="rule-grid">
						<div class="rule-card">
							<h3>5.1 支付方式</h3>
							<p>支持企业对公美元转账、合规数字资产结算，所有付费服务均可开具正规商业发票，留存交易凭证可查。</p>
						</div>
						<div class="rule-card">
							<h3>5.2 退费规则</h3>
							<p>SaaS 订阅、会员订阅：服务未启用可全额退费，启用后按实际使用时长折算退费；定制化项目服务，项目启动后非我方原因不予退费。</p>
						</div>
						<div class="rule-card">
							<h3>5.3 服务更新说明</h3>
							<p>平台保留根据行业市场、服务升级微调定价的权利，价格调整将提前 7 个工作日于官网 Pricing 页面公示，已付费用户不受调价影响。</p>
						</div>
					</div>
				</div>
			</section>
    </Layout>
</template>

<script>
    import Layout from '../components/common/Layout'

    export default {
        name: 'Pricing',
        components: {Layout},
        data() {
            return {}
        }
    }
</script>
<style scoped lang="scss">
.title {
	font-weight: 700;
	position: relative;
	font-size: 28px;
}
.block-gray {
	background-color: #f4f4f4;
}
.block-dark {
	background-color: #070a2b;
}
.principle {
	.principle-grid {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		.p-item {
			flex: 1;
			min-width: 240px;
			border: 1px solid #eee;
			border-left: 4px solid #0d6efd;
			border-radius: 8px;
			padding: 20px 24px;
			background: #fff;
			.p-label {
				font-size: 15px;
				color: #0d6efd;
				font-weight: 700;
				margin-bottom: 10px;
			}
			.p-value {
				font-size: 14px;
				color: #4d4d4d;
				line-height: 1.6;
			}
		}
	}
}
.section-head {
	display: flex;
	align-items: center;
	gap: 16px;
	margin-bottom: 20px;
	.sec-index {
		width: 44px;
		height: 44px;
		flex-shrink: 0;
		border-radius: 50%;
		background-color: #0d6efd;
		color: #fff;
		font-size: 22px;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	&.light .title {
		color: #fff;
	}
}
.sec-lead {
	font-size: 16px;
	line-height: 2;
	color: #4d4d4d;
	margin-bottom: 30px;
}
.sub-title {
	font-size: 20px;
	font-weight: 700;
	margin: 40px 0 20px;
	padding-left: 12px;
	position: relative;
	&:after {
		content: "";
		position: absolute;
		height: 70%;
		width: 4px;
		left: 0;
		top: 50%;
		transform: translateY(-50%);
		background-color: #0d6efd;
	}
}
.price-cards {
	display: flex;
	gap: 24px;
	align-items: stretch;
	.price-card {
		flex: 1;
		background: #fff;
		border: 1px solid #eee;
		border-radius: 12px;
		padding: 32px 26px;
		position: relative;
		transition: .4s;
		display: flex;
		flex-direction: column;
		.pc-tag {
			position: absolute;
			top: 0;
			right: 0;
			background: #0d6efd;
			color: #fff;
			font-size: 12px;
			padding: 4px 14px;
			border-radius: 0 12px 0 12px;
		}
		.pc-head {
			font-size: 20px;
			font-weight: 700;
			color: #1a1a1a;
		}
		.pc-scene {
			font-size: 13px;
			color: grey;
			margin-top: 6px;
			min-height: 20px;
		}
		.pc-price {
			font-size: 30px;
			font-weight: 800;
			color: #0d6efd;
			margin: 18px 0 6px;
			span {
				font-size: 15px;
				font-weight: 400;
				color: grey;
			}
			&.free {
				color: #28a745;
			}
		}
		.pc-year {
			font-size: 13px;
			color: #4d4d4d;
			margin-bottom: 16px;
			padding-bottom: 16px;
			border-bottom: 1px dashed #e0e0e0;
			min-height: 20px;
		}
		.pc-list {
			padding-left: 0;
			margin-top: 4px;
			li {
				font-size: 14px;
				color: #4d4d4d;
				line-height: 1.6;
				padding: 7px 0 7px 22px;
				position: relative;
				&:before {
					content: "";
					position: absolute;
					left: 2px;
					top: 14px;
					width: 6px;
					height: 6px;
					border-radius: 50%;
					background-color: #0d6efd;
				}
			}
		}
		&.featured {
			border-color: #0d6efd;
			box-shadow: 0 10px 30px rgba(13, 110, 253, .15);
			transform: translateY(-8px);
		}
		&:hover {
			box-shadow: 0 10px 30px rgba(13, 110, 253, .15);
		}
	}
}
.price-table {
	width: 100%;
	border-collapse: collapse;
	background: #fff;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 4px 20px rgba(0, 0, 0, .04);
	th, td {
		padding: 16px 20px;
		text-align: left;
		font-size: 15px;
		border-bottom: 1px solid #eee;
	}
	th {
		background-color: #0d6efd;
		color: #fff;
		font-weight: 600;
	}
	td {
		color: #4d4d4d;
		b {
			color: #0d6efd;
		}
	}
	tr:last-child td {
		border-bottom: none;
	}
	tbody tr:hover {
		background-color: #f6f9ff;
	}
}
.rule-grid {
	display: flex;
	gap: 24px;
	.rule-card {
		flex: 1;
		background: rgba(255, 255, 255, .05);
		border: 1px solid rgba(255, 255, 255, .1);
		border-radius: 12px;
		padding: 28px 24px;
		h3 {
			font-size: 18px;
			font-weight: 700;
			color: #0d6efd;
			margin-bottom: 14px;
		}
		p {
			font-size: 14px;
			color: #b6bbd4;
			line-height: 1.8;
		}
	}
}
@media screen and (max-width: 850px) {
	.principle .principle-grid,
	.price-cards,
	.rule-grid {
		flex-direction: column;
	}
	.price-cards .price-card.featured {
		transform: none;
	}
	.title {
		font-size: 20px;
	}
	.price-table {
		th, td {
			padding: 12px;
			font-size: 13px;
		}
	}
}
</style>
